import React from "react";
import styles from "./Sidebar.module.css";
import AddBoxIcon from "@mui/icons-material/AddBox";
import StorageIcon from "@mui/icons-material/Storage";

import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../config/firebaseConfig";

import { Link, useLocation } from "react-router-dom";

const Sidebar = () => {
  const [user, setUser] = React.useState(null);

  // get user from firebase
  React.useEffect(
    () =>
      onAuthStateChanged(auth, (user) => {
        if (user) {
          setUser({
            name: user.displayName,
            email: user.email,
          });
        } else {
          setUser(null);
        }
      }),
    []
  );

  // get current path
  const location = useLocation();

  return (
    <div className={styles.sidebar}>
      <Link to="/dashboard" className={styles.path}>
        <div
          className={
            location.pathname === "/dashboard"
              ? styles.activePath
              : styles.sidebarItem
          }
        >
          <div className={styles.sidebarItemIcon}>
            <AddBoxIcon />
          </div>
          <div className={styles.sidebarItemTitle}>Add Data</div>
        </div>
      </Link>
      {/* && user?.email === 'admin@gmail.com' */}
      {user?.email && (
        <Link to="/data" className={styles.path}>
          <div
            className={
              location.pathname === "/data"
                ? styles.activePath
                : styles.sidebarItem
            }
          >
            <div className={styles.sidebarItemIcon}>
              <StorageIcon />
            </div>
            <div className={styles.sidebarItemTitle}>Storage</div>
          </div>
        </Link>
      )}
    </div>
  );
};

export default Sidebar;
